import Immutable from 'seamless-immutable';
import { createReducer, completeState, completeReducer } from 'redux-recompose';

import { actions } from './actions';
import { PERIODS_DEFAULT_STATE } from './constants';

const completedState = completeState(PERIODS_DEFAULT_STATE);

const reducerDescription = {
  primaryActions: [
    actions.GET_ALL_ADDED_PERIODS,
    actions.ADD_PERIOD,
    actions.CREATE_PERIOD,
    actions.GET_ALL_PERIODS
  ]
};

const reducer = createReducer(new Immutable(completedState), completeReducer(reducerDescription));

export default reducer;
